var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-name-color-container", style: _vm.containerStyle },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.svgWidth,
            height: _vm.svgHeight,
            viewBox: "0 0 53 8",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            preserveAspectRatio: "none"
          }
        },
        [
          _c("title", [_vm._v("aiNameColor")]),
          _vm._v(" "),
          _c("defs", [
            _c(
              "filter",
              {
                attrs: {
                  x: "-3.1%",
                  y: "-33.9%",
                  width: "106.1%",
                  height: "167.9%",
                  filterUnits: "objectBoundingBox",
                  id: _vm.colorFilterId
                }
              },
              [
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "0.5 0", in: "SourceGraphic" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "首页",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "首页-ai选题-已生成",
                    fill: _vm.fillColor,
                    "fill-rule": "nonzero"
                  }
                },
                [
                  _c("g", { attrs: { id: "编组-79" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M48,4.41912809 C49.127404,4.26728216 49.1216438,2.53873464 47.9163167,2.57057588 C47.7889518,2.57329598 47.6619068,2.57329598 47.5318217,2.57857619 C48.3180924,2.189761 48.1822471,0.78602617 47.1154854,0.815307312 C36.8315487,0.561509191 26.5135149,0.467541037 16.1613842,0.53340285 C7.73717538,0.0887216509 3.08522438,-0.0779219889 2.20553123,0.0334719312 C1.04932606,0.0654731781 1.00596437,1.54105082 1.96568186,1.84474268 C1.6159082,1.84474268 1.26901465,1.84474268 0.919240985,1.84202257 C-0.31216712,1.83402226 -0.300646667,3.64785312 0.919240985,3.70369529 C2.23449236,3.76497769 3.72355897,3.68197734 5.03881035,3.72725911 C4.4395049,3.7115499 10.5150688,3.70369529 23.265502,3.70369529 C49.7807306,3.70369529 47.9989336,4.43474778 48,4.41912809 Z",
                        id: "路径",
                        filter: _vm.colorFilterUrl
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M48,4.41912809 C49.127404,4.26728216 49.1216438,2.53873464 47.9163167,2.57057588 C47.7889518,2.57329598 47.6619068,2.57329598 47.5318217,2.57857619 C48.3180924,2.189761 48.1822471,0.78602617 47.1154854,0.815307312 C36.8315487,0.561509191 26.5135149,0.467541037 16.1613842,0.53340285 C7.81005442,0.382329844 3.15810342,0.215686204 2.20553123,0.0334719312 C1.04932606,0.0654731781 1.00596437,1.54105082 1.96568186,1.84474268 C1.6159082,1.84474268 1.26901465,1.84474268 0.919240985,1.84202257 C-0.31216712,1.83402226 -0.300646667,3.64785312 0.919240985,3.70369529 C2.23449236,3.76497769 3.72355897,3.68197734 5.03881035,3.72725911 C4.4395049,3.7115499 10.5150688,3.70369529 23.265502,3.70369529 C49.7807306,3.70369529 47.9989336,4.43474778 48,4.41912809 Z",
                        id: "路径"
                      }
                    })
                  ])
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0120ebc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0120ebc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/ai-name-color/ai-name-color.vue
// module id = null
// module chunks = 